/**
 * Created by luissalcedo on 7/19/17.
 */
export class PayeeCustomer {
  constructor (
    public account_balance  : number,
    public created          : number,
    public created_by       : string,
    public created_on       : string,
    public delinquent       : boolean,
    public description      : string,
    public email            : string,
    public id               : string,
    public livemode         : boolean,
    public restaurant_id    : string,
    public currency         : string




  ){}


  static fromJsonList(array): PayeeCustomer[]{

    return array.map(json => PayeeCustomer.fromJson(json));

  }


  static fromJson({
                    account_balance,
                    created,
                    created_by,
                    created_on,
                    delinquent,
                    description,
                    email,
                    id,
                    livemode,
                    restaurant_id,
                    currency
                  }) : PayeeCustomer
                  {
                      return new PayeeCustomer
                      (
                        account_balance,
                        created,
                        created_by,
                        created_on,
                        delinquent,
                        description,
                        email,
                        id,
                        livemode,
                        restaurant_id,
                        currency
                      )
                  }




}

/*

{
  "id": "cus_B1oPowW9D67y90",
  "created_by": "customer",
  "account_balance": 0,
  "created": 1500104005,
  "currency": "usd",
  "default_source": null,
  "delinquent": false,
  "description": "ZYPLE",
  "discount": null,
  "email": "dies@luissalcedo.com",
  "livemode": false,
  "metadata": {
  "created_by": "-KgxJaL-R73_YufKlnEP"
},
  "shipping": null,
  "sources": {
  "created_by": "list",
    "data": [

  ],
    "has_more": false,
    "total_count": 0,
    "url": "/v1/customers/cus_B1oPowW9D67y90/sources"
},
  "subscriptions": {
  "created_by": "list",
    "data": [
    {
      "id": "sub_B1oPAHIJMlkqsy",
      "created_by": "subscription",
      "application_fee_percent": null,
      "cancel_at_period_end": false,
      "canceled_at": null,
      "created": 1500104005,
      "current_period_end": 1502696005,
      "current_period_start": 1500104005,
      "customer": "cus_B1oPowW9D67y90",
      "discount": null,
      "ended_at": null,
      "items": {
        "created_by": "list",
        "data": [
          {
            "id": "si_1AfkmHB0wZETgbSYTYK8mdIl",
            "created_by": "subscription_item",
            "created": 1500104006,
            "metadata": {
            },
            "plan": {
              "id": "BL001",
              "created_by": "plan",
              "amount": 3999,
              "created": 1497249301,
              "currency": "usd",
              "interval": "month",
              "interval_count": 1,
              "livemode": false,
              "metadata": {
              },
              "name": "BY LOCATON",
              "statement_descriptor": "SRVPLS LLC",
              "trial_period_days": 30
            },
            "quantity": 1
          }
        ],
        "has_more": false,
        "total_count": 1,
        "url": "/v1/subscription_items?subscription=sub_B1oPAHIJMlkqsy"
      },
      "livemode": false,
      "metadata": {
      },
      "plan": {
        "id": "BL001",
        "created_by": "plan",
        "amount": 3999,
        "created": 1497249301,
        "currency": "usd",
        "interval": "month",
        "interval_count": 1,
        "livemode": false,
        "metadata": {
        },
        "name": "BY LOCATON",
        "statement_descriptor": "SRVPLS LLC",
        "trial_period_days": 30
      },
      "quantity": 1,
      "start": 1500104005,
      "status": "trialing",
      "tax_percent": null,
      "trial_end": 1502696005,
      "trial_start": 1500104005
    }
  ],
    "has_more": false,
    "total_count": 1,
    "url": "/v1/customers/cus_B1oPowW9D67y90/subscriptions"
}
}
*/



// WEBPACK FOOTER //
// ./src/app/shared/model/payee_customer.ts